export const COUNTER_CHANGE = "COUNTER_CHANGE";
export const ACCEPT_GA_COOKIES = "ACCEPT_GA_COOKIES";
export const SHOW_BANNER_COOKIES = "SHOW_BANNER_COOKIES";
export const SHOW_BANNER_CUSTOMISE = "SHOW_BANNER_CUSTOMISE";
export const SAVE_COOKIES_PREFERENCES = "SAVE_COOKIES_PREFERENCES";
export const SET_CUSTOMISE_COOKIES='SET_CUSTOMISE_COOKIES';